import React, { Component } from "react";
import PropTypes from "prop-types";

import i18n from "../../../../translations/i18n";
import { SEARCHABLE_ARTIST_SHAPE } from "../../../../constants/searchConstants";
import Image from "../image";
import Link from "../../../../components/ui/link";


class Artist extends Component {

  constructor(props) {
    super(props);
  }

  render () {
    const { item } = this.props;

    return (
      <Link
        key={item.id}
        to={item.path}
        className="p-search__results-list-item"
      >
        <div className="p-search__results-list-item-info">
          <div className="p-search__results-list-item-info-description">
            <ul>
              <li>
                <strong>
                  {i18n.t(`pages.search.results.${item.kind}.title`)}
                </strong>
              </li>
              { item.year_of_birth && item.year_of_death &&
                <li>
                  {i18n.t('pages.artists.years', {birth: item.year_of_birth, death: item.year_of_death})}
                </li>
              }
            </ul>
          </div>
          <div className="p-search__results-list-item-info-name">
            {item.name}
          </div>
        </div>
        <Image item={item} />
      </Link>
    );
  }
}

Artist.propTypes = {
  item: PropTypes.shape(SEARCHABLE_ARTIST_SHAPE).isRequired,
};

export default Artist;